module.exports = __webpack_public_path__ + "media/application/images/features/inventory-syncing-1600-56c709c7f6b9846cfdcef46e26464d4e.png";